import { render, staticRenderFns } from "./fixShop.vue?vue&type=template&id=07c2ff26&scoped=true&"
import script from "./fixShop.vue?vue&type=script&lang=js&"
export * from "./fixShop.vue?vue&type=script&lang=js&"
import style0 from "./fixShop.vue?vue&type=style&index=0&id=07c2ff26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2ff26",
  null
  
)

export default component.exports